import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useMobileMenuState } from "../../../../../store/mobileMenu/mobileMenu.selectors";

import { NavItem } from "../NavItem/NavItem";
import AnonymizerLink from "./components/AnonymizerLink";

import { NavStack } from "./Navigation.styled";

export const Navigation = () => {
  const [activeType, setActiveType] = useState(null);
  const { t } = useTranslation();

  const isOpen = useMobileMenuState();

  const handleActiveTypeChange = type => {
    setActiveType(type);
  };

  return (
    <NavStack component="nav" isOpen={isOpen}>
      <AnonymizerLink />

      <NavItem
        type="tools"
        activeType={activeType}
        setActiveType={handleActiveTypeChange}
      >
        {t("header.freeTools")}
      </NavItem>

      <NavItem
        type="proxies"
        activeType={activeType}
        setActiveType={handleActiveTypeChange}
      >
        {t("header.personalBtn")}
      </NavItem>
    </NavStack>
  );
};
